import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Outlet } from "react-router";
import { onUnauthorized } from "../api/client";
import { Toaster } from "../components/ui/sonner";
import { TooltipProvider } from "../components/ui/tooltip";
import { useApplyTheme } from "../hooks/useTheme";
import { queryKeys } from "../lib/queryKeys";

export function RootLayout() {
  const queryClient = useQueryClient();
  useApplyTheme();

  // Any 401 means the session is gone: mark the user signed out so guards redirect to /login.
  useEffect(
    () =>
      onUnauthorized(() => {
        if (queryClient.getQueryData(queryKeys.me) !== null)
          queryClient.setQueryData(queryKeys.me, null);
      }),
    [queryClient],
  );

  return (
    <TooltipProvider>
      <Outlet />
      <Toaster position="bottom-right" />
    </TooltipProvider>
  );
}
